export default "__VITE_ASSET__DDeiHDmy__"